import React from 'react';
import {
    Col,
    Button,
    FormGroup,
    Label,
    Form,
    Modal,
    ModalHeader,
    ModalBody
} from 'reactstrap';
import InputMask from 'react-input-mask';

export default function ModalAddUser(props) {
    const { 
        modalAddUser, 
        toggleModalAddUser, 
        modalAddUserTitle, 
        register,
        errors,
        type,
        handleSubmit,
        onSubmitInvite,
        isReceiver,
        emailError,
        phoneError,
        isAddingUser
    } = props;

    return (
        <Modal isOpen={modalAddUser} toggle={toggleModalAddUser}>
            <ModalHeader toggle={toggleModalAddUser}>
                {modalAddUserTitle}
            </ModalHeader>
            <ModalBody>
            <Form>
                <FormGroup row>
                    <Label
                    for="name"
                    sm={2}
                    >
                        Name
                    </Label>
                    <Col sm={10}>
                        <input
                        type="text"
                        name="name"
                        id="name"
                        ref={register}
                        className="form-control" 
                        />
                        {errors.name && (
                            <p className="error-validation-left">
                                {
                                    errors.name.message
                                }
                            </p>
                        )}
                        <input
                        type="hidden"
                        name="type"
                        id="type"
                        ref={register}
                        value="1" 
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label
                    for="email"
                    sm={2} 
                    >
                        Email
                    </Label>
                    <Col sm={10}>
                        <input
                        type="email"
                        name="email"
                        id="email"
                        ref={register}
                        className="form-control" 
                        />
                        {isReceiver && isReceiver === true && (
                            <div className="mt-2">
                                <input
                                    id="noemail"
                                    name="noemail"
                                    type="checkbox"
                                    ref={register}
                                    className="mr-2"
                                />
                                Senior does not has an email
                            </div>
                        )}
                        {errors.email && (
                            <p className="error-validation-left">
                                {
                                    errors.email
                                        .message
                                }
                            </p>
                        )}
                        {emailError && (
                            <p className="error-validation-left">
                                {
                                    emailError
                                }
                            </p>
                        )}
                        <input
                        type="hidden"
                        name="type"
                        id="type"
                        ref={register}
                        value="1" 
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label
                    for="phone"
                    sm={2} 
                    >
                        Phone
                    </Label>
                    <Col sm={10}>
                        {/* <input
                        type="text"
                        name="phone"
                        id="phone"
                        ref={register}
                        className="form-control" 
                        /> */}
                        <InputMask
                            mask="(999) 999-9999"
                            name="phone"
                            id="phone"
                            inputRef={register}
                            className="form-control" 
                        />
                        {errors.phone && (
                            <p className="error-validation-left">
                                {
                                    errors.phone.message
                                }
                            </p>
                        )}
                        {phoneError && (
                            <p className="error-validation-left">
                                {
                                    phoneError
                                }
                            </p>
                        )}
                        <input
                        type="hidden"
                        name="type"
                        id="type"
                        ref={register}
                        value={type}
                        />
                    </Col>
                </FormGroup>
                <FormGroup check row>
                    <Col
                    sm={{
                        size: 15,
                        offset: 2,
                    }}
                    >
                        <Button
                            onClick={handleSubmit(
                                onSubmitInvite
                            )}
                            color="info"
                            disabled={isAddingUser === true}
                        >
                            Add
                        </Button>
                        <Button
                            onClick={toggleModalAddUser}
                            color="secondary"
                            className="ml-2"
                        >
                            Cancel
                        </Button>
                    </Col>
                </FormGroup>
            </Form>
            </ModalBody>
        </Modal>
    );
}
